import React from 'react';
import { useCart } from '../elementsui/CartContext';
import { Link, useLocation } from 'react-router-dom';
import './BottomCartNav.css';

const BottomCartNav = () => {
  const { cartItems, totalPrice } = useCart();
  const location = useLocation();

  if (location.pathname === '/cart') return null;

  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <div className="bottom-cart-nav-wrapper">
      <div className="bottom-cart-nav">
        <div className="bottom-cart-content">
          <div className="cart-summary">
            <span>{totalItems} item{totalItems !== 1 ? 's' : ''}</span>

          </div>
          <Link to="/cart" className="view-cart-btn">
          <span className='px-2 '>₹{totalPrice.toFixed(2)}  |  View Cart <i className='bi bi-chevron-right'></i></span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BottomCartNav;
 